import { useInjectReducer, useInjectSaga } from 'redux-injectors';
import { useActions } from '../../../common/hooks';
import { instoreReducer, instoreActions, instoreName } from '../slice';
import { instoreRootSaga } from '../saga';

export const useInstoreSlice = () => {
	useInjectReducer({ key: instoreName, reducer: instoreReducer });
	useInjectSaga({ key: instoreName, saga: instoreRootSaga });
	return useActions(instoreActions);
};
